import script from "./scene-price-mgmt-config.vue?vue&type=script&lang=tsx&setup=true"
export * from "./scene-price-mgmt-config.vue?vue&type=script&lang=tsx&setup=true"

import "./scene-price-mgmt-config.vue?vue&type=style&index=0&id=66db6c22&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66db6c22"]])

export default __exports__